import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils.js';

export type QuestionSoftTimerProps = {
  secondsLeft: number | null;
  overtime: boolean;
  estimatedSeconds: number;
  className?: string;
};

export function QuestionSoftTimer({
  secondsLeft,
  overtime,
  estimatedSeconds,
  className,
}: QuestionSoftTimerProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {secondsLeft !== null ? (
        <span
          className={cn(
            'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 font-mono text-[12px] tabular-nums transition',
            overtime
              ? 'bg-[color-mix(in_srgb,var(--ig-danger)_15%,var(--ig-bg-secondary))] text-ig-danger'
              : secondsLeft < 15
                ? 'bg-[color-mix(in_srgb,var(--ig-accent)_15%,var(--ig-bg-secondary))] text-ig-accent'
                : 'bg-ig-bg-secondary text-ig-text-tertiary',
          )}
        >
          <span
            className={cn(
              'h-1.5 w-1.5 rounded-full',
              overtime ? 'bg-ig-danger' : secondsLeft < 15 ? 'bg-ig-accent' : 'bg-ig-text-tertiary',
            )}
          />
          {overtime
            ? t('interview.active.timer.overtime', { defaultValue: 'Overtime' })
            : `${Math.max(0, secondsLeft)}s`}
        </span>
      ) : null}
      <span className="font-sans text-[11px] text-ig-text-tertiary">
        {t('interview.active.timer.suggested', {
          mins: Math.round(estimatedSeconds / 60),
          defaultValue: `Suggested: ~${Math.round(estimatedSeconds / 60)} min`,
        })}
      </span>
    </div>
  );
}
